export default "__VITE_ASSET__1ebf2a13__"